import script from "./Countdown.vue?vue&type=script&lang=ts&setup=true"
export * from "./Countdown.vue?vue&type=script&lang=ts&setup=true"

import "./Countdown.vue?vue&type=style&index=0&id=0f6d3908&scope=true&lang=css"

const __exports__ = script;

export default __exports__